import React, { memo } from "react";
import Skeleton from "@mui/material/Skeleton";
import { Card, CardContent, CardHeader } from "components/ui";
import { FieldRowSkeleton } from "./SettingCardSkeleton";

const ProfileSkeleton = memo(() => {
  return (
    <div className="grid gap-5 lg:gap-7.5 xl:w-[38.75rem] mx-auto">
      <Card className="min-w-full">
        <CardHeader>
          <Skeleton variant="text" width={120} height={32} />
        </CardHeader>
        <CardContent className="grid gap-5">
          <div className="flex flex-col mt-2 justify-center items-center gap-x-2.5">
            <Skeleton variant="circular" width={96} height={96} />
          </div>
          <FieldRowSkeleton />
          <FieldRowSkeleton />
          <div className="flex justify-center">
            <Skeleton
              variant="rounded"
              width={84}
              height={36}
              sx={{ borderRadius: "6px" }}
            />
          </div>
        </CardContent>
      </Card>
    </div>
  );
});

ProfileSkeleton.displayName = "ProfileSkeleton";

export default ProfileSkeleton;
